import { useState, useCallback } from "react";

const useModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleModal = useCallback(() => {
    setIsVisible((prevState) => !prevState);
  }, []);

  return {
    isVisible,
    toggleModal,
  };
};

export default useModal;
